import { initialize as _initialize, checkInitialized, buildUrl } from "@spica-devkit/internal_common";
import { getWsObs } from "./operators";
let authorization;
let wsUrl;
let service;
export function initialize(options) {
    const { authorization: _authorization, publicUrl, service: _service } = _initialize(options);
    authorization = _authorization;
    service = _service;
    wsUrl = (publicUrl + "/bucket").replace("http", "ws");
    service.setWriteDefaults({
        headers: {
            "Content-Type": "application/json"
        }
    });
}
export function get(id) {
    checkInitialized(authorization);
    return service.get(`bucket/${id}`);
}
export function getAll() {
    checkInitialized(authorization);
    return service.get("bucket");
}
export function insert(bucket) {
    checkInitialized(authorization);
    return service.post("bucket", bucket);
}
export function update(id, bucket) {
    checkInitialized(authorization);
    return service.put(`bucket/${id}`, bucket);
}
export function remove(id) {
    checkInitialized(authorization);
    return service.delete(`bucket/${id}`);
}
export var data;
(function (data) {
    function get(bucketId, documentId, options = {}) {
        checkInitialized(authorization);
        return service.get(`bucket/${bucketId}/data/${documentId}`, {
            params: options.queryParams,
            headers: options.headers
        });
    }
    data.get = get;
    function getAll(bucketId, options = {}) {
        checkInitialized(authorization);
        return service.get(`bucket/${bucketId}/data`, {
            params: options.queryParams,
            headers: options.headers
        });
    }
    data.getAll = getAll;
    function insert(bucketId, document) {
        checkInitialized(authorization);
        return service.post(`bucket/${bucketId}/data`, document);
    }
    data.insert = insert;
    function update(bucketId, documentId, document) {
        checkInitialized(authorization);
        return service.put(`bucket/${bucketId}/data/${documentId}`, document);
    }
    data.update = update;
    function patch(bucketId, documentId, document) {
        checkInitialized(authorization);
        return service.patch(`bucket/${bucketId}/data/${documentId}`, document);
    }
    data.patch = patch;
    function remove(bucketId, documentId) {
        checkInitialized(authorization);
        return service.delete(`bucket/${bucketId}/data/${documentId}`);
    }
    data.remove = remove;
    let realtime;
    (function (realtime) {
        function get(bucketId, documentId, messageCallback) {
            checkInitialized(authorization);
            const fullUrl = buildUrl(`${wsUrl}/${bucketId}/data`, {
                filter: `document._id=="${documentId}"`,
                Authorization: authorization
            });
            return getWsObs(fullUrl.toString(), undefined, documentId, messageCallback);
        }
        realtime.get = get;
        function getAll(bucketId, queryParams = {}, messageCallback) {
            checkInitialized(authorization);
            const sort = queryParams["sort"];
            const fullUrl = buildUrl(`${wsUrl}/${bucketId}/data`, {
                ...queryParams,
                Authorization: authorization
            });
            return getWsObs(fullUrl.toString(), sort, undefined, messageCallback);
        }
        realtime.getAll = getAll;
    })(realtime = data.realtime || (data.realtime = {}));
})(data || (data = {}));
//# sourceMappingURL=bucket.js.map